// removed by extract-text-webpack-plugin
module.exports = {"Text":"_3yC8D","dashboard-is-editing":"_3Nt-8","text-card-textarea":"_3KwDU","text-card-markdown":"_1J_Mq"};


//////////////////
// WEBPACK FOOTER
// ./visualizations/visualizations/Text.css
// module id = 467
// module chunks = 3 4 5